import { isEqual } from 'lodash';
import React from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button } from 'rizzui';
import CustomSelect from '../../../../../components/forms/CustomSelect';
import DateField from '../../../../../components/forms/DateField';
import { usePrivilege } from '../../../../../components/priviledge/PriviledgeProvider';
import useCompanies from '../../../../../hooks/api-calls/useCompanies';
import { pickupStatuses } from '../../../../../utils/SelectorMapping';
import useUsers from '../../../../../hooks/api-calls/useUsers';

interface PickupStatusHistoryFiltersProps {
    updateFilters: (filters: any) => void;
    filters: any;
}

const PickupStatusHistoryFilters: React.FC<PickupStatusHistoryFiltersProps> = ({ filters, updateFilters }) => {

    // HOOKS

    const { userCan } = usePrivilege();
    const { getCompaniesList } = useCompanies();
    const { getUsersList } = useUsers();

    // RENDER 

    return (
        <>
            <CustomSelect
                id="user"
                label="Usuarios"
                placeholder="usuarios"
                options={getUsersList() || []}
                value={filters.filter_filters?.user ? getUsersList()?.filter(user => filters.filter_filters?.user.includes(user.value)) || [] : []}
                onChange={(value: any) => updateFilters({ user: value.map((item: any) => item.value) })}
                isClearable={true}
                isMulti={true}
                isSearchable={true}
                isLoading={!getUsersList()}
            />

            <CustomSelect
                id="previousStatus"
                label="Estado anterior"
                placeholder="estados anteriores"
                options={pickupStatuses}
                value={pickupStatuses.filter((item: any) => filters.filter_filters?.previousStatus?.includes(item.value))}
                onChange={(value: any) => updateFilters({ previousStatus: value.map((item: any) => item.value) })}
                isClearable={true}
                isMulti={true}
            />

            <CustomSelect
                id="newStatus"
                label="Nuevo Estado"
                placeholder="estados siguientes"
                options={pickupStatuses}
                value={pickupStatuses.filter((item: any) => filters.filter_filters?.newStatus?.includes(item.value))}
                onChange={(value: any) => updateFilters({ newStatus: value.map((item: any) => item.value) })}
                isClearable={true}
                isMulti={true}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fechas de cambio de estado"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.change?.from ? new Date(filters.filter_filters.change.from) : null}
                endDate={filters.filter_filters?.change?.to ? new Date(filters.filter_filters.change.to) : null}
                onChange={(date: any) => {
                    const filters_change = filters.filter_filters?.change;
                    const change = date ? { from: date[0], to: date[1] } : null;

                    if (change && !isEqual(filters_change, change)) {
                        updateFilters({ change });
                    } else if (!change && filters_change) {
                        updateFilters({ change: null });
                    }
                }}
            />

            {userCan('list', 'company') && (
                <CustomSelect
                    isSearchable
                    id="company"
                    label="Compañía"
                    options={getCompaniesList()}
                    value={getCompaniesList().find((item: any) => item.value === filters.filter_filters?.company) ?? { label: 'Todas', value: 'null' }}
                    onChange={(e: any) => {
                        if (e.value === 'null') {
                            updateFilters({ company: null });
                            return;
                        }
                        updateFilters({ company: e.value });
                    }}
                />
            )}

        </>
    );
};

export default PickupStatusHistoryFilters;